package exchange.dydx.abacus.di

import exchange.dydx.abacus.AsyncAbacusStateManagerV2
import exchange.dydx.abacus.protocols.DataNotificationProtocol
import exchange.dydx.abacus.protocols.PresentationProtocol
import exchange.dydx.abacus.protocols.StateNotificationProtocol
import exchange.dydx.abacus.state.supervisor.AppConfigsV2
import exchange.dydx.abacus.utils.IOImplementations
import exchange.dydx.abacus.utils.UIImplementations
import kotlin.reflect.KClass
import me.tatarka.inject.`internal`.LazyMap
import me.tatarka.inject.`internal`.ScopedComponent

public fun KClass<AbacusComponent>.create(
  deploymentUri: DeploymentUri,
  deployment: Deployment,
  appConfigs: AppConfigsV2,
  ioImplementations: IOImplementations,
  uiImplementations: UIImplementations,
  stateNotification: StateNotificationProtocol?,
  dataNotification: DataNotificationProtocol?,
  presentationProtocol: PresentationProtocol?,
): AbacusComponent = InjectAbacusComponent(deploymentUri, deployment, appConfigs, ioImplementations,
    uiImplementations, stateNotification, dataNotification, presentationProtocol)

public class InjectAbacusComponent(
  deploymentUri: DeploymentUri,
  deployment: Deployment,
  appConfigs: AppConfigsV2,
  ioImplementations: IOImplementations,
  uiImplementations: UIImplementations,
  stateNotification: StateNotificationProtocol?,
  dataNotification: DataNotificationProtocol?,
  presentationProtocol: PresentationProtocol?,
) : AbacusComponent(deploymentUri, deployment, appConfigs, ioImplementations, uiImplementations,
    stateNotification, dataNotification, presentationProtocol), ScopedComponent {
  override val _scoped: LazyMap = LazyMap()

  override val stateManager: AsyncAbacusStateManagerV2
    get() = _scoped.get("exchange.dydx.abacus.AsyncAbacusStateManagerV2") {
      AsyncAbacusStateManagerV2(
        deploymentUri = deploymentUri,
        deployment = deployment,
        appConfigs = appConfigs,
        ioImplementations = ioImplementations,
        uiImplementations = uiImplementations,
        stateNotification = stateNotification,
        dataNotification = dataNotification,
        presentationProtocol = presentationProtocol
      )
    }
}
